// @mui material components
import Grid from "@mui/material/Grid";

// Argon Dashboard 2 PRO MUI components
import WhiteLabelForm from "0.Mine/0.Components/Admin/WhiteLabel";
import AddOrRemoveBusinesses from "0.Mine/0.Components/Profile/Billing/ConnectedBusinesses";
import ArgonBox from "components/ArgonBox";

// Settings page components
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import Accounts from "layouts/pages/account/settings/components/Accounts";
import Authentication from "layouts/pages/account/settings/components/Authentication";
import BasicInfo from "layouts/pages/account/settings/components/BasicInfo";
import ChangePassword from "layouts/pages/account/settings/components/ChangePassword";
import DeleteAccount from "layouts/pages/account/settings/components/DeleteAccount";
import Header from "layouts/pages/account/settings/components/Header";
import Notifications from "layouts/pages/account/settings/components/Notifications";
import Sessions from "layouts/pages/account/settings/components/Sessions";
import Sidenav from "layouts/pages/account/settings/components/Sidenav";

function Settings() {
  return (
    <BaseLayout>
      <ArgonBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Sidenav />
          </Grid>
          <Grid item xs={12} lg={9}>
            <ArgonBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Header />
                </Grid>
                <Grid item xs={12}>
                  <AddOrRemoveBusinesses />
                </Grid>
                <Grid item xs={12}>
                  <WhiteLabelForm />
                </Grid>
              </Grid>
              {/*<Grid item xs={12}>
                  <ChangePassword />
                </Grid>
                <Grid item xs={12}>
                  <Authentication />
                </Grid>
                <Grid item xs={12}>
                  <Accounts />
                </Grid>
                <Grid item xs={12}>
                  <Notifications />
                </Grid>
                <Grid item xs={12}>
                  <Sessions />
                </Grid>
                <Grid item xs={12}>
                  <DeleteAccount />
                </Grid>*/}
            </ArgonBox>
          </Grid>
        </Grid>
      </ArgonBox>
    </BaseLayout>
  );
}

export default Settings;
